import React, {useContext, useState, useEffect} from "react"
import VisibilitySensor from "react-visibility-sensor"
import {PageContext} from "../../../context/PageContext"
import {withRouter} from "react-router-dom"
import {createBrowserHistory} from "history"

const Section = ({slug, children}) => {
    const {page, updatePage} = useContext(PageContext)
    const [currentSlug, setCurrentSlug] = useState(null)

    const handleChange = e => {
        updatePage({pageSlug: page.pageSlug, sectionSlug: slug})
        setCurrentSlug(slug)
        // console.log(createBrowserHistory().location.hash)
    } 

    return (
        <VisibilitySensor 
            key={slug}
            partialVisibility
            onChange={(isVisible, e) => {
                isVisible && handleChange(e)
            }} 
        >
            <section
                key={slug}
                id={slug}
                /*
                className={
                    history?.location?.hash === `#${slug}`
                        ? "active"
                        : ""
                }
                */

                data-delay=".7s"
            >
                <article className="section__container">{children}</article>
            </section>
        </VisibilitySensor>
    )
}
export default Section
